import { useRouteContext } from "@tanstack/react-router";

import type { User } from "@/lib/user";

export function useAuth() {
  const user = useRouteContext({
    strict: false,
    select: (s) => (s as { user: User }).user,
  });
  return { user };
}

export * from "./idle-timeout";
